<template>
    <div>
        <h3>Temporary ID Card</h3>

        <div v-if="!dental" class="mb-5" >
            <p>This member is not eligible for an ID card.  Please review products and coverage.</p>
        </div>

        <div v-else class="mb-5" >
            <p>A request has been made to have an ID card created. In the meantime you can use this temporary ID card.</p>

            <div class="mb-5" v-if="member && (member.underwriter === '001' || member.underwriter === '002' || member.underwriter === '004')">
                <div class="id-card">
                    <img src="@/assets/images/temp_ids/001_front.png" class="id-card"/>
                    <span class="group">{{member.underwriter}}{{member.group}}</span>
                    <span class="name">{{member.firstName}} {{member.lastName}}</span>
                    <span class="cert">{{member.cert}}</span>
                    <span class="tier">{{dental.tier}}</span>
                    <span class="date">{{dental.effective_date}}</span>
                </div>
                <div class="id-card mt-3">
                    <img src="@/assets/images/temp_ids/001_back.png" class="id-card"/>
                </div>
            </div>
            <div class="mb-5" v-if="member && (member.underwriter === '003')">
                <div class="id-card">
                    <img src="@/assets/images/temp_ids/003_front.png" class="id-card"/>
                    <span class="group">{{member.underwriter}}{{member.group}}</span>
                    <span class="name">{{member.firstName}} {{member.lastName}}</span>
                    <span class="cert">{{member.cert}}</span>
                    <span class="tier">{{dental.tier}}</span>
                    <span class="date">{{dental.effective_date}}</span>
                </div>
                <div class="id-card mt-3">
                    <img src="@/assets/images/temp_ids/003_back.png" class="id-card"/>
                </div>
            </div>
            <div class="mb-5" v-if="member && (member.underwriter === '007')">
                <div class="id-card">
                    <img src="@/assets/images/temp_ids/007_front.png" class="id-card"/>
                    <span class="group">{{member.underwriter}}{{member.group}}</span>
                    <span class="name">{{member.firstName}} {{member.lastName}}</span>
                    <span class="cert">{{member.cert}}</span>
                    <span class="tier">{{dental.tier}}</span>
                    <span class="date">{{dental.effective_date}}</span>
                </div>
                <div class="id-card mt-3">
                    <img src="@/assets/images/temp_ids/007_back.png" class="id-card"/>
                </div>
            </div>
            <div class="mb-5" v-if="member && (member.underwriter === '010')">
                <div class="id-card">
                    <img src="@/assets/images/temp_ids/010_front.png" class="id-card"/>
                    <span class="group">{{member.underwriter}}{{member.group}}</span>
                    <span class="name">{{member.firstName}} {{member.lastName}}</span>
                    <span class="cert">{{member.cert}}</span>
                    <span class="tier">{{dental.tier}}</span>
                    <span class="date">{{dental.effective_date}}</span>
                </div>
                <div class="id-card mt-3">
                    <img src="@/assets/images/temp_ids/010_back.png" class="id-card"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TempIDCard',
        components: {},
        props: ['member'],
        computed: {
            dental: function() {
                if (this.member && this.member.plans) {
                    for (let i = 0; i < this.member.plans.length; i++) {
                        const plan = this.member.plans[i];
                        if (plan.product === 'DE') return plan;
                    }
                } else {
                    return null;
                }
            }
        }
    }
</script>

<style scoped>
    .id-card {
        position: relative;
        font-size: 12px;
    }

    .id-card .group {
        position: absolute;
        left: 95px;
        top: 95px;
    }

    .id-card .name {
        position: absolute;
        left: 94px;
        top: 142px;
    }

    .id-card .cert {
        position: absolute;
        left: 113px;
        top: 165px;
    }

    .id-card .tier {
        position: absolute;
        left: 103px;
        top: 193px;
        width: 140px;
        line-height: 12px;
    }

    .id-card .date {
        position: absolute;
        left: 132px;
        top: 236px;
    }

    .id-card img {
        width: 500px;
    }
</style>
